export default function setUser(actionContext, user) {
  actionContext.dispatch('setUser', user);
}
